import * as E from 'fp-ts/lib/Either'
import { pipe } from 'fp-ts/lib/pipeable'
import { sequenceS } from 'fp-ts/lib/Apply'

import {
  AP,
  gte,
  metaPath,
  required,
  Validator
} from '@espoon-voltti/ts-libs/lib/validation'

import {
  DraftNuoraOrg,
  Members,
  NuoraOrg
} from '@espoon-voltti/nuora-domain/applicants'

export const nuoraOrgV =
  (path: ReadonlyArray<string>): Validator<DraftNuoraOrg, NuoraOrg> =>
  (x) =>
    pipe(
      sequenceS(AP)({
        targetGroup: required([...path, 'targetGroup'])(x.targetGroup),
        activity: required([...path, 'activity'])(x.activity),
        members: membersV([...path, 'members'])(x.members)
      }),
      E.map((valid) => valid as NuoraOrg)
    )

const membersV =
  (path: ReadonlyArray<string>): Validator<Members, Members> =>
  (x) =>
    pipe(
      x.from21to28 + x.from29 + x.from7to20,
      gte(metaPath(path), 1),
      E.map((_) => x)
    )
